module.exports = __webpack_public_path__ + "img/5.24e36407.jpg";